import ApiRoutes from "../../../constants/api-routes";
import { hneInsightApi } from "../../../service";

export const createNewInsight = async (body) =>
  hneInsightApi.post(`${ApiRoutes.CREATE_INSIGHT}`, body);

export const createNewsImpression = async (body) =>
  hneInsightApi.post(`${ApiRoutes.CREATE_NEWS_IMPRESSION}`, body);

export const createSiteImpression = async (body) =>
  hneInsightApi.post(`${ApiRoutes.CREATE_SITE_IMPRESSION}`, body);
